import React from 'react';
import { Formik } from 'formik';
import Yup from 'yup';

import CompensationSubmissionForm from './CompensationSubmissionForm/compensationSubmissionForm';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import { compensationEditUrl, userCompensationsUrl } from 'buyside/util/urlHelper';

const compensationSchema = Yup.object().shape({
  title: Yup.string().required('This field is required'),
  experience: Yup.string().required('This field is required'),
  industry: Yup.string().required('This field is required'),
  location: Yup.string().required('This field is required'),
  fundType: Yup.string().required('This field is required'),
  fundStrategy: Yup.string().required('This field is required'),
  fundSize: Yup.string().required('This field is required'),
  assetClass: Yup.string().required('This field is required'),
  baseSalary: Yup.string().required('This field is required')
});

const currentYear = new Date().getFullYear();

const blankEstimated = {
  status: 'draft',
  year: currentYear,
  category: 'estimated',
  title: '',
  experience: '',
  industry: '',
  location: '',
  fundType: '',
  fundStrategy: '',
  fundSize: '',
  assetClass: '',
  baseSalary: '',
  interestMgmtFeesPerc: '',
  interestMgmtFeesValue: '',
  vestingMgmtFees: '',
  interestIncentiveFeesPerc: '',
  interestIncentiveFeesValue: '',
  vestingIncentiveFees: '',
  annualDiscrBonus: '',
  totalDeferredComp: '',
  investInFund: false,
  buildPersonalTrackRecord: false,
  marketPersonalTrackRecord: false,
  comments: '',
  mode: 'new'
};

class CompensationEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pageNum: 1 };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(args, { resetForm }) {
    const { updateCompensation, createCompensation, currentUser } = this.props;
    const actualDraft = currentUser.draftCompensations.find(comp => comp.category === 'actual');
    const estimateDraft = currentUser.draftCompensations.find(
      comp => comp.category === 'estimated'
    );

    if (args.id) {
      updateCompensation(args).then(({ data }) => {
        if (data.updateCompensation.compensation.category === 'actual') {
          if (estimateDraft) {
            window.location.assign(compensationEditUrl(estimateDraft.id));
          } else {
            this.setState({ pageNum: 2 }, () => {
              blankEstimated.actualComp = data.updateCompensation.compensation;
              resetForm(blankEstimated);
              window.scrollTo(0, 0);
            });
          }
        } else {
          if (args.status === 'draft') updateCompensation(args);
          else {
            updateCompensation({ id: actualDraft.id, status: 'published' });
            updateCompensation(args);
          }
          window.location.assign(userCompensationsUrl());
        }
      });
    } else {
      createCompensation(args).then(({ data }) => {
        if (data.createCompensation.compensation.status === 'draft')
          window.location.assign(userCompensationsUrl());
        else {
          updateCompensation({ id: actualDraft.id, status: 'published' });
          createCompensation(args);
          window.location.assign(userCompensationsUrl());
        }
      });
    }
  }

  render() {
    const {
      compensation,
      compensationLoading,
      compensationError,
      currentUserLoading,
      userError
    } = this.props;

    if (userError) {
      if (userError.message.include('401')) {
        window.location.reload();
      }
      throw userError;
    } else if (compensationError) {
      throw compensationError;
    }
    if (currentUserLoading || compensationLoading) return <LoadingSpinner size="large" />;

    const firstRender = Object.assign({}, compensation, { mode: 'edit' });

    let headerCategory, headerYear, pageNum;
    if (this.state.pageNum === 1 && compensation.category === 'actual') {
      pageNum = 1;
      headerCategory = 'Actual';
      headerYear = currentYear - 1;
    } else {
      pageNum = 2;
      headerCategory = 'Estimated';
      headerYear = currentYear;
    }
    return (
      <div>
        <h3>
          {pageNum}. Edit {headerCategory} Compensation for {headerYear}
        </h3>
        <Formik
          initialValues={firstRender}
          component={CompensationSubmissionForm}
          onSubmit={this.handleSubmit}
          validationSchema={compensationSchema}
        />
      </div>
    );
  }
}

export default CompensationEditPage;
